module.exports = __webpack_public_path__ + "img/heating.8e670bde.png";